import { ECarSettings } from "./ecar";

export class RangeParams {
    public RangeInputParams!: ECarSettings;
    public Waypoints: Waypoint[] = [];
}

export class Waypoint{
    public lat: number;
    public lng: number;
    public csid?: string;

    constructor(lat: number, lng: number, csid?: string) {
        this.lat = lat;
        this.lng = lng;
        if (csid){
            this.csid = csid;
        }
    }
}
